import { request, requestList, orgBase } from '@/api/http'
import type {
  Source,
  CreateSourceRequest,
  UpdateSourceRequest,
  IngestResult,
} from '@/api/types'

const scope = (orgId: string, invId: string) =>
  `${orgBase(orgId)}/inventories/${invId}/sources`

export const sourcesApi = {
  list(orgId: string, invId: string): Promise<Source[]> {
    return requestList(scope(orgId, invId))
  },
  get(orgId: string, invId: string, sid: string): Promise<Source> {
    return request(`${scope(orgId, invId)}/${sid}`)
  },
  create(orgId: string, invId: string, body: CreateSourceRequest): Promise<Source> {
    return request(scope(orgId, invId), { method: 'POST', body: JSON.stringify(body) })
  },
  update(orgId: string, invId: string, sid: string, body: UpdateSourceRequest): Promise<Source> {
    return request(`${scope(orgId, invId)}/${sid}`, { method: 'PUT', body: JSON.stringify(body) })
  },
  remove(orgId: string, invId: string, sid: string): Promise<void> {
    return request(`${scope(orgId, invId)}/${sid}`, { method: 'DELETE' })
  },
  // Ingest a CycloneDX file (multipart) or raw JSON payload.
  ingest(orgId: string, invId: string, sid: string, file: File | string): Promise<IngestResult> {
    if (typeof file === 'string') {
      return request(`${scope(orgId, invId)}/${sid}/ingest`, { method: 'POST', body: file })
    }
    const form = new FormData()
    form.append('file', file)
    return request(`${scope(orgId, invId)}/${sid}/ingest`, { method: 'POST', body: form })
  },
  refresh(orgId: string, invId: string, sid: string): Promise<IngestResult> {
    return request(`${scope(orgId, invId)}/${sid}/refresh`, { method: 'POST' })
  },

  // ── Org-wide (inventory-agnostic) — sources management page ──────────────
  listAll(orgId: string): Promise<Source[]> {
    return requestList(`${orgBase(orgId)}/sources`)
  },
  assign(orgId: string, sid: string, inventoryId: string | null): Promise<void> {
    return request(`${orgBase(orgId)}/sources/${sid}/inventory`, {
      method: 'PUT',
      body: JSON.stringify({ inventory_id: inventoryId }),
    })
  },
  removeOrg(orgId: string, sid: string): Promise<void> {
    return request(`${orgBase(orgId)}/sources/${sid}`, { method: 'DELETE' })
  },
}
